import { DEV } from "solid-js"
import { Color, MeshBasicMaterial, MeshLambertMaterial, MeshStandardMaterial, ShaderMaterial, SpriteMaterial, type Object3D } from "three"
import type { Engine } from "../../core/engine/Engine.type"
import type { EntityGraphNode } from "../../core/engine/EntityGraphNode/EntityGraphNode.type"
import { isEntityInfantry } from "../../core/entity/entityTypeMetaList.generated"
import tmpRngWith from "../../core/rng/tmpRngWith"
import { freeze } from "../../core/util/Object"
import bindReactiveColorToMaterial from "../PlayerThreeObject/bindReactiveColorToMaterial"
import applyLuminanceFromGreyscale from "./applyLuminanceFromGreyscale"
import randomSkinToneRGB from "./randomSkinToneColor"

// narrow down to the materials this file should be concerned with
type MaterialUnion = MeshBasicMaterial | MeshStandardMaterial | MeshLambertMaterial

const lightGray : Readonly<Color> = new Color(0xaaaaaa)
if (DEV) {
  freeze(lightGray)
}

export default function applyPlayerColors (
  engine: Engine,
  group: Object3D,
  entNode: EntityGraphNode,
): void {
  // const baseMaterial = getEntityColor1Material(engine, ent)

  // if (isEntityMediumTank(ent)) {
  //   console.log('applyPlayerColors.MediumTank', deepClone(ent))
  //   console.log('pto.player.color1', playerColorToHex(pto.player?.color1))
  //   console.log('pto.material.color1', pto.material?.color.getHexString())
  // }

  group.traverse((obj) => {
    const material : MaterialUnion | null = (obj as typeof obj & {material : MaterialUnion | null}).material
    if (material) {

      if (material.userData.Window) {
        // if (isEntityBuilding(ent) && !ent.player_id) {
        //   console.log('NonPlayer: material.userData.Window', material, group, deepClone(ent))
        //   return
        // }
        // for now
        // console.log('material.userData.Window', material)
        return
      }
      if (material instanceof ShaderMaterial) {
        return
      }

      if (material instanceof MeshStandardMaterial) {
        material.metalness = 0.5
        material.roughness = 0.5
      }
  
      if (material instanceof SpriteMaterial) {
        // IDK ignore SpriteMaterial
        return
      }
      const PC = material.userData.PC
      if (PC===0) {
        return
      }
      // console.log('PC', PC)
      if (PC || isEntityInfantry(entNode)) {
        // const obj2 = obj as typeof obj & {material : MaterialUnion}
        if (!(material instanceof MeshBasicMaterial)
          && !(material instanceof MeshLambertMaterial)
          && !(material instanceof MeshStandardMaterial)) {
          console.log('applyPlayerColors.material', material)
          throw new Error('material is not a MeshBasicMaterial | MeshStandardMaterial | MeshLambertMaterial')
        }
        if (isEntityInfantry(entNode)) {
          // console.log('material', material)
          // if ((material instanceof MeshStandardMaterial)) {
          //   console.log('applyPlayerColors.material', material.color.getHexString(), material.name, material)
          //   // throw new Error('material is a MeshStandardMaterial')
          // }

          // if ([
          //   'Skin',
          //   'Main',
          //   'Black',
          //   'Grey',
          //   'Face',
          //   'Helmet',
          // ].includes(material.name)) {

          if (material.name === 'Skin') {
            const skinColor = randomSkinToneRGB(tmpRngWith(entNode.id))
            material.color = skinColor
            // not necessary for only changing color
            // material.needsUpdate = true
          } else if (material.name === 'Face') {
            material.color = new Color(0x000000)
            // not necessary for only changing color
            // material.needsUpdate = true
          } else if (material.name === 'Black') {
            const tmpColor = new Color()
            bindReactiveColorToMaterial(material, () => {
              tmpColor.set(entNode.color1())
              return applyLuminanceFromGreyscale(lightGray, tmpColor, tmpColor)
            })
          } else {
            bindReactiveColorToMaterial(material, entNode.color1)
          }
          return
        }

        // console.log(entityDisplayName(ent), ent.id, 'material', material)

        const color0 : Readonly<Color> = material.color
        const tmpColor = new Color()
        bindReactiveColorToMaterial(material, () => {
          tmpColor.set(entNode.color1())
          return applyLuminanceFromGreyscale(color0, tmpColor, tmpColor)
        })
      }
    }
  })
}
